// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"683bf165cb9fa2cbd739","655":"f6f3e75797730dfeffe9"}[chunkId] + ".js";
};